<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[9999] flex flex-col gap-3 max-w-sm">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="[
            'flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border text-sm font-medium cursor-pointer',
            toastClasses[toast.type]
          ]"
          @click="removeToast(toast.id)"
        >
          <component :is="toastIcons[toast.type]" class="w-5 h-5 flex-shrink-0" />
          <span>{{ toast.message }}</span>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import { CheckCircle2, XCircle, Info, AlertTriangle } from 'lucide-vue-next'

const { toasts, removeToast } = useToast()

const toastClasses: Record<string, string> = {
  success: 'bg-green-50 dark:bg-green-900/80 text-green-800 dark:text-green-100 border-green-200 dark:border-green-700',
  error: 'bg-red-50 dark:bg-red-900/80 text-red-800 dark:text-red-100 border-red-200 dark:border-red-700',
  info: 'bg-blue-50 dark:bg-blue-900/80 text-blue-800 dark:text-blue-100 border-blue-200 dark:border-blue-700',
  warning: 'bg-yellow-50 dark:bg-yellow-900/80 text-yellow-800 dark:text-yellow-100 border-yellow-200 dark:border-yellow-700'
}

const toastIcons: Record<string, any> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
  warning: AlertTriangle
}
</script>

<style scoped>
.toast-enter-active {
  transition: all 0.3s ease-out;
}
.toast-leave-active {
  transition: all 0.2s ease-in;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.toast-move {
  transition: transform 0.3s ease;
}
</style>
